// import './Minicart.scss'
const freeShippingAmount = 299;
const freeGifts = [4836269555817];

const _EVApi = axios.create({
//   baseURL: 'https://evolvehub-staging.azurewebsites.net/api',
  baseURL: 'https://evolvehub.azurewebsites.net/api',
  responseType: 'json',
  headers: { 
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${sessionStorage.getItem("EvolveToken")}` 
    }
})

_EVApi.interceptors.request.use(
    config => {
        config.headers.Authorization = `Bearer ${sessionStorage.getItem("EvolveToken")}`
        return config;
    },
    error => Promise.reject(error)
);

const _EVStorage = {
    get : function(property){
        return property?JSON.parse(localStorage.getItem('EvolveHUB_Storage'))[property]:JSON.parse(localStorage.getItem('EvolveHUB_Storage'))
    },
    set : function(property, value){
        let currentStorage = _EVStorage.get();
        currentStorage[property] = value;
        localStorage.setItem('EvolveHUB_Storage', JSON.stringify(currentStorage))
    },
    delete : function(property, value){
        let currentStorage = _EVStorage.get();
        delete currentStorage[property];
        localStorage.setItem('EvolveHUB_Storage', JSON.stringify(currentStorage))
    },

}

Vue.component('cart-wrapper', {
    template: `
        <div class="Minicart" >
            <div class="Minicart__Section" v-if="cart">
                <CartEmpty v-if="cart.item_count === 0" />
                <CartContent v-if="cart.item_count > 0" />
            </div>
        </div>
    `,
    computed: {
        ...Vuex.mapGetters([
            'cart'
        ])
    },
    created(){
        // debugger;
        this.getCart({runCallback:false})
            .then((cart)=>{
                EvolveCore.Checkout.GetStatus(cart.token).then((checkoutStatus)=>{
                    if(checkoutStatus.isClosed){
                      this.getCart()  
                    }
                })
            });
    },
    methods:{
        ...Vuex.mapActions([
            'getCart'
        ]),
        changeToken(){
            this.getCart();
        }

    }
})
Vue.component('CartEmpty', {
    template: `
        <div class="Minicart__Empty">
            <div class="Minicart__Empty--CTA">
                <img src="https://cdn.shopify.com/s/files/1/0275/9049/2259/files/logo-cinza_57611bde-b2a3-47f9-a96f-805f8b8209e6_500x@2x.png?v=1572376003" width="100px">
                <b>Ops,</b>
                sua sacola está vazia
            </div>
        </div>
    `,
    computed: {
        ...Vuex.mapGetters([
            'cart',
            'bundles'
        ])
    },
    created(){
        // alert('OPS.. SEU CARRINHO ESTÁ VAZIO')
    },
    methods:{}
})

Vue.component('CartContent', {
    template: `
        <div class="Minicart__Content">
            <div class="Minicart__Top">
                <CartHeader/>
                <Promotion :promotions="bundles.promotions" type="default"  v-if="bundles && bundles.promotions.length > 0"/>
                <div class="Minicart__Free-Shipping">
                    <div v-if="!CartHasFreeShipping">
                        <span v-if="FreeShippingMessage !== null">
                            <span>
                                {{FreeShippingMessage}}
                            </span>
                        </span>
                        <span v-else>
                            <span>Por mais <span class="moneyFormat">{{ $options.filters.formatMoney((freeShippingAmount - CartTotalPrice ))}}</span> o frete é grátis</span>
                            <span class="Minicart__Free-Shipping--Progress Progress">
                                <span class="Progress--Total"></span>
                                <span class="Progress--Actual" v-bind:style="{ maxWidth: ((CartTotalPrice/freeShippingAmount)*100) + '% ' }"></span>
                            </span>
                        </span>
                        
                    </div>
                    <div v-else><span>PARABÉNS, VOCÊ GANHOU FRETE GRÁTIS!</span></div>
                </div>
            </div>
            <div class="Minicart__Middle" ref="prodList" v-bind:class="{'overflow': isOverflowing || cart.items.length > 3 }">
                <transition name="fade">
                    <ProductArea/>
                </transition>
                <transition name="fade">
                    <Bundle :bundles="bundles.bundles" type="default"  v-if="bundles && bundles.bundles.length > 0"/>
                </transition>
            </div>
            <div class="Minicart__Bottom">
                <transition name="fade">
                    
                </transition>
                <Totals/>
            </div>
        </div>
    `,
    data(){
        return{
            FreeShippingMessage: null,
            isOverflowing: false
        }
    },
    updated(){
        var element = this.$refs.prodList;
        this.isOverflowing = (element && element.offsetHeight < element.scrollHeight || element && element.offsetWidth < element.scrollWidth)
    },
    computed: {
        ...Vuex.mapGetters([
            'CartState',
            'ShippingTypes',
            'Shipping',
            'cart',
            'Coupons',
            'bundles'
        ]),
        freeShippingAmount(){
            return freeShippingAmount
        },
        CartHasFreeShipping(){
            return (!!this.Coupons.appliedDiscounts && !!this.Coupons.appliedDiscounts.filter(coupon => coupon.type === 'shipping').length) || (this.CartTotalPrice > this.freeShippingAmount)
        },
        CartTotalDiscounts(){
            let cartTotalDiscount = this.cart.total_discount? parseFloat(this.cart.total_discount / 100) : 0;
            let DiscountsTotalAmount = this.Coupons.appliedDiscounts ? 
                this.Coupons.appliedDiscounts.reduce(function(prev, cur) {
                    return prev + cur.amount / 100;
                }, 0) : 
                0;
            return cartTotalDiscount + DiscountsTotalAmount
        },
        CartTotalPrice(){
            let CartOriginalTotalPrice = this.cart.original_total_price? parseFloat(this.cart.original_total_price / 100) : 0;
            let ShippingPrice = this.Shipping.shippingRate? parseFloat(this.Shipping.shippingRate.price) : 0;
            let CartTotalDiscounts = this.CartTotalDiscounts? parseFloat(this.CartTotalDiscounts) : 0;

            return (CartOriginalTotalPrice + ShippingPrice) - CartTotalDiscounts
        },
    },
    watch: { 
        CartHasFreeShipping: function(value, oldValue) {
            if(this.Shipping.zip){
                this.getZipInfos({'type':this.Shipping.type,'zip':this.Shipping.zip,'country':this.Shipping.country,'province':this.Shipping.province})
            }
        }
    },
    created() {
        // debugger;
        // this.getCart();
        var element = this.$refs.prodList;
        this.isOverflowing = (element && element.offsetHeight < element.scrollHeight || element && element.offsetWidth < element.scrollWidth)
    },
    methods: {
        ...Vuex.mapActions([
            'getCart',
            'clearCart',
            'getZipInfos'
        ])
    }
})

Vue.component('CartHeader', {
    template: `
        <div class="Minicart__Header">
            Seu carrinho
            <a class="Minicart__Header--Close" @click="closeCart"><Icon icon="CloseIcon" /></a>
        </div>
    `,
    computed: {
        ...Vuex.mapGetters([
            'cart'
        ])
    },
    created() {
        // debugger;
        // this.getCart();
    },
    methods: {
        ...Vuex.mapActions([
            'getCart',
            'clearCart'
        ]),
        closeCart(){
            EvolveCore._helpers.triggerEvent(`cart:hide`)
        }
    }
})
// 
// 
// 
Vue.component('Promotion', {
    template: `
        <div class="Minicart__Bundle Promotion" v-loading="CartState.bundles === 'LOADING'" element-loading-spinner="Minicart__LoadingAnimation">
            <div class="Minicart__Bundle--Inner" style=" background: #fbb117; padding: 5px 10px; font-weight: bold; color: #000; ">
                <div class="Minicart__Bundle--Content">
                    <div v-for="promotion in enabledPromotions.slice(0,1)" :key="promotion._id" v-bind:class="{'Multiple-Slides': enabledPromotions.length > 1}" class="Minicart__Bundle--Item">
                        <div class="Minicart__Bundle--Infos">
                            <a style="font-weight: bold; color: #000;"
                            :href="promotion.url" target="_blank" class="Minicart__Bundle--Description" v-html="promotion.description"></a>
                        </div>
                        <swiper :options="promotionsSwiperOptions" ref="promotionsSwiper" class="Minicart__Bundle--Products" v-bind:class="{'Multiple-Products': bundles.length === 1}" v-if="!promotion.allowAutomatedAdd">
                            <swiper-slide class="Minicart__Bundle__Product" v-for="product in enabledPromotionProducts(promotion.products)" :key="product._id">
                                <div class="Minicart__Bundle__Product--Inner"  @click="setProductsToSelect([product])">
                                    <div class="Minicart__Bundle__Product__Title">
                                        <div>
                                            <b>{{product.name}}</b>
                                        </div>
                                    </div>
                                    <div class="Minicart__Bundle__Product--Image">
                                        <div class="Minicart__Bundle__Product--Image--Inner">
                                            <img :src="product.image" />
                                        </div>
                                    </div>
                                    <div class="Minicart__Bundle__Product--Infos">
                                        <!-- <div class="Minicart__Bundle__Product__Discount">
                                            <b>{{product.discountRate * 100}}%</b>
                                        </div> -->
                                        <div class="Minicart__Bundle--Actions">
                                            <transition name="fade">
                                                <el-button size="mini" class="btn btn-sm">
                                                    <!-- addBundleProducts(product) -->
                                                    Adicionar
                                                    <span class="moneyFormat">{{product.variants[0].price?$options.filters.formatMoney(product.variants[0].price) : 'GRÁTIS'}}</span>
                                                </el-button>
                                            </transition>
                                        </div>
                                    </div>
                                </div>
                            </swiper-slide>
                            </swiper>
                            <div class="swiper-meta"  v-if="!promotion.allowAutomatedAdd">
                                <div class="swiper-button-prev" slot="button-prev">
                                    <Icon icon="ArrowPrev"/>
                                </div>
                                <div class="swiper-button-next" slot="button-next">
                                    <Icon icon="ArrowNext"/>
                                </div>
                            </div>
                    </div>
                </div>
                <transition name="fade">
                    <BundleVariantSelector class="Minicart__Bundle--VariantSelector" v-if="ProductsToSelect" :products="ProductsToSelect" @bundle-products-added="setProductsToSelect(null)"/>
                </transition>
            </div>
        </div>
    `,
    computed: {
        ...Vuex.mapGetters([
            'CartState',
            'cart',
            'Coupons'
        ]),
        swiper() {
            return this.$refs.promotionsSwiper?this.$refs.promotionsSwiper[0].swiper:null
        },
        enabledPromotions(){
            let enabledPromotions = this.promotions.map((promotion) => {
                promotion.products.map((product) => {
                    product.inventoryQty = product.variants.reduce(function (a, b) {
                        return b['inventoryQty'] == null ? a : a + b['inventoryQty'];
                    }, 0);
                    return product
                })
                promotion.products = promotion.products.filter((product) => {
                    return product
                    // return product.type !== 'Fronha de Travesseiro'
                })
                promotion.inventoryQty = promotion.products.reduce(function (a, b) {
                    return b['inventoryQty'] == null ? a : a + b['inventoryQty'];
                }, 0)
                return promotion
            }).filter((promotion) => {
                return promotion
            });
            enabledPromotions = enabledPromotions.length > 0 ? enabledPromotions.filter((promotion)=>{
                return ((promotion.activeVariantsCount === undefined || promotion.activeVariantsCount > 0) && promotion.allowAddToCart !== true)
            }):[]
            // debugger;
            return enabledPromotions
            // return enabledPromotions.sort(function (a, b) {
            //     return b.products.length - a.products.length;
            // });
        }
    },
    components: {
	},
    props: ['promotions', 'type'],
    created() {
    },
    mounted() {
        if(this.swiper){this.swiper.update();}
    },
    updated() {
        if(this.swiper){this.swiper.update();}
        this.$nextTick(() => {
            let e = event;
            if (e){
                this.changeHeight(e)
            }
        })
    },
    data(){
        return{
            bundlesFlipped:[],
            ProductsToSelect: null,
            promotionsSwiperOptions: {
                // loop: true,
                simulateTouch: true,
                watchOverflow: true,
                slidesPerView: 3,
                spaceBetween: 10,
                // centeredSlides: true,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                }
            },
        }
    },
    methods: {
        ...Vuex.mapActions([
            'getCart',
            'addProduct'
        ]),
        onSetTranslate() {
            //debugger;
            this.swiper.update();
        },
        changeHeight(e){
            setTimeout(function() {
                let FlipWrapper = $(e.target).parents('.Minicart__Bundle--Content').length > 0 ? $(e.target).parents('.Minicart__Bundle--Content') : $(e.target);
                let flipFront = FlipWrapper.find('.Card--Front');
                let flipBack = FlipWrapper.find('.Card--Back');
                let flipHeight = flipBack.outerHeight();
                flipFront.css('min-height', flipHeight>30?flipHeight:'')
            }, 250);
        },
        
        enabledPromotionProducts(products){
            return products.length > 0 ? products.filter((product)=>{
                return product.activeVariantsCount === undefined || product.activeVariantsCount > 0
            }):[]
        },
        getBundleVariant(bundleID,prodID,propertiesOBJ){
            delete propertiesOBJ.variantSelected
            let properties = Object.values(propertiesOBJ);
            properties = [properties.join(' / ')]
            let foundBundles = bundle => promotion._id === bundleID
            let GetBundleProducts = bundle => promotion.products
            let foundProducts = product => product._id === prodID
            let GetBundleProductVariants = product => product.variants
            let foundVariants = 
                this.promotions
                    .filter(foundBundles)
                    .map(GetBundleProducts)
                    .flat()
                    .filter(foundProducts)
                    .map(GetBundleProductVariants)
                    .flat();
            let matchedVariants = foundVariants;
            
            for (let i = 0; i < properties.length; i++) {
                const property = properties[i];
                matchedVariants = matchedVariants.filter(
                    // variant => variant.name.indexOf(property) > -1
                    variant => variant.name === property
                )
            }

            return matchedVariants
        },
        getBundleImage(bundleOBJ, type) {
            if (!bundleOBJ){
                return '//cdn.shopify.com/s/files/1/1526/6199/files/produto--banner-principal_767x.jpg';
            }
            var imgURL = bundleOBJ.images.filter(function(item){
                return item.type == type
            })[0].url || '//cdn.shopify.com/s/files/1/1526/6199/files/produto--banner-principal_767x.jpg';
            return imgURL;
        },
        addBundleProducts(selectedBundleProducts){ 
            let addProductOBJNormalized = selectedBundleProducts.map((variantItem)=>{
                let addProductOBJ = {
                    variant: {
                        key: variantItem._id
                    },
                    amount: 1
                }
                return addProductOBJ
            })
            this.addProduct(addProductOBJNormalized);
        },
        setProductsToSelect(ProductsARR){
            this.ProductsToSelect = ProductsARR;
        }
    },
    watch: { 
        bundles: function(newBundle, oldBundle) {
            if(JSON.stringify(newBundle) !== JSON.stringify(oldBundle)){
                this.variantsSelected = {}
                // this.setCartRules(newBundle)
            }
        }
    }
})
Vue.component('Bundle', {
    template: `
        <div class="Minicart__Bundle Recommendation" v-loading="CartState.bundles === 'LOADING'" element-loading-spinner="Minicart__LoadingAnimation">
            <div class="Minicart__Bundle--Inner">
                <div class="Minicart__Bundle--Content">
                    <div v-for="bundle in enabledBundles.splice(0,1)" :key="bundle._id" v-bind:class="{'Multiple-Slides': enabledBundles.length > 1}" class="Minicart__Bundle--Item">
                        <swiper :options="swiperOption" ref="mySwiper" class="Minicart__Bundle--Products" v-bind:class="{'Multiple-Products': bundles.length === 1}" >
                            <swiper-slide class="Minicart__Bundle__Product" v-for="product in enabledBundleProducts(bundle.products)" :key="product._id">
                                <div class="Minicart__Bundle__Product--Inner"  @click="setProductsToSelect([product])">
                                    <div class="Minicart__Bundle__Product__Title">
                                        <div>
                                            <b>{{product.name}}</b>
                                        </div>
                                    </div>
                                    <div class="Minicart__Bundle__Product--Image">
                                        <div class="Minicart__Bundle__Product--Image--Inner">
                                            <img :src="product.image" />
                                        </div>
                                    </div>
                                    <div class="Minicart__Bundle__Product--Infos">
                                        <!-- <div class="Minicart__Bundle__Product__Discount">
                                            <b>{{product.discountRate * 100}}%</b>
                                        </div> -->
                                        <div class="Minicart__Bundle--Actions">
                                            <transition name="fade">
                                                <el-button size="mini" class="btn btn-sm">
                                                    <!-- addBundleProducts(product) -->
                                                    Adicionar
                                                    <span class="moneyFormat">{{product.variants[0].price?$options.filters.formatMoney(product.variants[0].price) : 'GRÁTIS'}}</span>
                                                </el-button>
                                            </transition>
                                        </div>
                                    </div>
                                </div>
                            </swiper-slide>
                            </swiper>
                            <div class="swiper-meta">
                                <div class="swiper-button-prev" slot="button-prev">
                                    <Icon icon="ArrowPrev"/>
                                </div>
                                <div class="swiper-button-next" slot="button-next">
                                    <Icon icon="ArrowNext"/>
                                </div>
                            </div>
                    </div>
                </div>
                <transition name="fade">
                    <BundleVariantSelector class="Minicart__Bundle--VariantSelector" v-if="ProductsToSelect" :products="ProductsToSelect" @bundle-products-added="setProductsToSelect(null)"/>
                </transition>
            </div>
        </div>
    `,
    computed: {
        ...Vuex.mapGetters([
            'CartState',
            'cart',
            'Coupons'
        ]),
        swiper() {
            return this.$refs.mySwiper?this.$refs.mySwiper[0].swiper:null
        },
        enabledBundles(){
            let enabledBundles = this.bundles.map((bundle) => {
                bundle.products.map((product) => {
                    product.inventoryQty = product.variants.reduce(function (a, b) {
                        return b['inventoryQty'] == null ? a : a + b['inventoryQty'];
                    }, 0);
                    return product
                })
                bundle.products = bundle.products.filter((product) => {
                    return product
                    // return product.type !== 'Fronha de Travesseiro'
                })
                bundle.inventoryQty = bundle.products.reduce(function (a, b) {
                    return b['inventoryQty'] == null ? a : a + b['inventoryQty'];
                }, 0)
                return bundle
            }).filter((bundle) => {
                return bundle
            });
            enabledBundles = enabledBundles.length > 0 ? enabledBundles.filter((bundle)=>{
                return (bundle.activeVariantsCount === undefined || bundle.activeVariantsCount > 0)
            }):[]
            // debugger;
            return enabledBundles
            // return enabledBundles.sort(function (a, b) {
            //     return b.products.length - a.products.length;
            // });
        }
    },
    components: {
	},
    props: ['bundles', 'type'],
    created() {
    },
    mounted() {
        if(this.swiper){this.swiper.update();}
    },
    updated() {
        if(this.swiper){this.swiper.update();}
        this.$nextTick(() => {
            let e = event;
            if (e){
                this.changeHeight(e)
            }
        })
    },
    data(){
        return{
            bundlesFlipped:[],
            ProductsToSelect: null,
            swiperOption: {
                // loop: true,
                simulateTouch: true,
                watchOverflow: true,
                slidesPerView: 2,
                spaceBetween: 10,
                // centeredSlides: true,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                }
            },
        }
    },
    methods: {
        ...Vuex.mapActions([
            'getCart',
            'addProduct'
        ]),
        onSetTranslate() {
            //debugger;
            this.swiper.update();
        },
        changeHeight(e){
            setTimeout(function() {
                let FlipWrapper = $(e.target).parents('.Minicart__Bundle--Content').length > 0 ? $(e.target).parents('.Minicart__Bundle--Content') : $(e.target);
                let flipFront = FlipWrapper.find('.Card--Front');
                let flipBack = FlipWrapper.find('.Card--Back');
                let flipHeight = flipBack.outerHeight();
                flipFront.css('min-height', flipHeight>30?flipHeight:'')
            }, 250);
        },
        
        enabledBundleProducts(products){
            return products.length > 0 ? products.filter((product)=>{
                return product.activeVariantsCount === undefined || product.activeVariantsCount > 0
            }):[]
        },
        getBundleVariant(bundleID,prodID,propertiesOBJ){
            delete propertiesOBJ.variantSelected
            let properties = Object.values(propertiesOBJ);
            properties = [properties.join(' / ')]
            let foundBundles = bundle => bundle._id === bundleID
            let GetBundleProducts = bundle => bundle.products
            let foundProducts = product => product._id === prodID
            let GetBundleProductVariants = product => product.variants
            let foundVariants = 
                this.bundles
                    .filter(foundBundles)
                    .map(GetBundleProducts)
                    .flat()
                    .filter(foundProducts)
                    .map(GetBundleProductVariants)
                    .flat();
            let matchedVariants = foundVariants;
            
            for (let i = 0; i < properties.length; i++) {
                const property = properties[i];
                matchedVariants = matchedVariants.filter(
                    // variant => variant.name.indexOf(property) > -1
                    variant => variant.name === property
                )
            }

            return matchedVariants
        },
        getBundleImage(bundleOBJ, type) {
            if (!bundleOBJ){
                return '//cdn.shopify.com/s/files/1/1526/6199/files/produto--banner-principal_767x.jpg';
            }
            var imgURL = bundleOBJ.images.filter(function(item){
                return item.type == type
            })[0].url || '//cdn.shopify.com/s/files/1/1526/6199/files/produto--banner-principal_767x.jpg';
            return imgURL;
        },
        addBundleProducts(selectedBundleProducts){ 
            let addProductOBJNormalized = selectedBundleProducts.map((variantItem)=>{
                let addProductOBJ = {
                    variant: {
                        key: variantItem._id
                    },
                    amount: 1
                }
                return addProductOBJ
            })
            this.addProduct(addProductOBJNormalized);
        },
        setProductsToSelect(ProductsARR){
            this.ProductsToSelect = ProductsARR;
        }
    },
    watch: { 
        bundles: function(newBundle, oldBundle) {
            if(JSON.stringify(newBundle) !== JSON.stringify(oldBundle)){
                this.variantsSelected = {}
                // this.setCartRules(newBundle)
            }
        }
    }
})
Vue.component('BundleVariantSelector', {
    template: `
        <div class="Minicart__Bundle--VariantSelector">
            <div class="Minicart__Bundle--VariantSelector--Header">
                <a @click="CloseVariantSelector">Fechar</a>
            </div>
            <div class="Minicart__Bundle--VariantSelector--Content">
                <div class="Minicart__Bundle--SelectedProducts" v-for="product in EnabledProducts" :key="product._id">
                    <label>Selecione um tamanho para <b>{{product.name}}</b></label>
                    <el-select v-model="product.variantSelected" placeholder="Selecione" class="Minicart__Bundle--VariantSelector--Select">
                        <el-option
                            v-for="variant in product.variants"
                            :key="variant._id"
                            :label="variant.name"
                            :value="variant._id">
                        </el-option>
                    </el-select>
                </div>
                <el-button size="mini" class="btn" v-if="variantsSelected.length === products.length" @click="addBundleProducts(variantsSelected)">
                    Adicionar PRODUTOS
                </el-button>
            </div>
        </div>
    `,
    computed: {
        ...Vuex.mapGetters([
            'CartState',
            'cart'
        ]),
        EnabledProducts(){
            return this.products.filter((product)=>{
                product.variants = product.variants.filter((variant)=>{
                    // return variant.inventoryQty > 0
                    return variant
                })
                // return product.inventoryQty > 0
                return product
            })
        },
        variantsSelected(){
            return this.products.filter((item)=>{
                return item.variantSelected
            }).map((item)=>{
                return item.variantSelected
            })
        }
    },
    props:['products'],
    created() {
        // this.getCart();
        if(this.products){
            this.products.map((product)=>{
                if(product.variants.length === 1){
                    product.variantSelected = product.variants[0]._id
                }
                return product
            })
            if(this.variantsSelected.length === this.products.length){
                this.addBundleProducts(this.variantsSelected)
            }
        }
    },
    methods: {
        ...Vuex.mapActions([
            'getCart',
            'clearCart',
            'addProduct'
        ]),
        addBundleProducts(selectedBundleProducts){ 
            let addProductOBJNormalized = selectedBundleProducts.map((variantItem)=>{
                let addProductOBJ = {
                    variant: {
                        key: variantItem
                    },
                    amount: 1
                }
                return addProductOBJ
            })
            this.addProduct(addProductOBJNormalized);
            this.CloseVariantSelector()
        },
        CloseVariantSelector(){
            this.products.map((product)=>{
                delete product.variantSelected
                return product
            })
            this.$emit('bundle-products-added');
        }
    }
})
Vue.component('ProductArea', {
    template: `
        <div class="Minicart__ProductArea">
            <transition-group name="fade">

                <div class="Minicart__ProductItem" v-for="product in cart.items" v-loading="CartState.product === 'LOADING'" element-loading-spinner="Minicart__Splash" :key="product.key" :class="{'Item--Promotion': product.original_line_price > 0 && product.original_line_price > product.line_price}">
                    <ProductItem :product="product" />
                </div>
            
            </transition-group>

        </div>
    `,
    computed: {
        ...Vuex.mapGetters([
            'CartState',
            'cart'
        ])
    },
    created() {
    },
    methods: {
        ...Vuex.mapActions([
            'getCart',
            'clearCart'
        ])
    }
})


Vue.component('ProductItem', {
    template: `
        <div class="Minicart__ProductItem--Inner">
            <div class="Minicart__ProductItem__Data">
                <div class="Minicart__ProductItem__Image">
                    <img :src="product.image" />
                </div>
            </div>
            <div class="Minicart__ProductItem__Infos">
                <div>
                    <div class="Minicart__ProductItem__Title">
                        <span>{{product.product_title}}</span> {{product.variant_title}}
                    </div>
                    <div class="Minicart__ProductItem__Properties">
                        <span>
                            {{product.properties['Escolha suas Lentes de Grau']}}
                        </span>
                    </div>
                    <div class="Minicart__ProductItem__Quantity">
                        <div class="Minicart__ProductItem__Quantity__Button--minus" @click="decreaseQty([{'variant':product, 'amount':1}])">
                            <Icon icon="MinusIcon"/>
                        </div>
                        <input type="text" :value="product.quantity">
                        <div class="Minicart__ProductItem__Quantity__Button--plus" @click="increaseQty([{'variant':product, 'amount':1}])" v-bind:class="{'Minicart__ProductItem__Quantity__Button--disabled': freeGifts.includes(product.id)}">
                            <Icon icon="PlusIcon"/>
                        </div>
                    </div>
                </div>
                <div class="Minicart__ProductItem__Pricing">
                    <div class="Minicart__ProductItem__Price OldPrice" v-if="product.original_line_price > 0 && product.original_line_price > product.line_price">
                        <span class="moneyFormat">{{product.original_line_price?$options.filters.formatMoney(product.original_line_price/100) : 'GRÁTIS'}}</span>
                    </div>
                    <div class="Minicart__ProductItem__Price">
                        <span class="moneyFormat">{{product.line_price?$options.filters.formatMoney(product.line_price/100) : 'GRÁTIS'}}</span>
                    </div>
                </div>
            </div>
        </div>
    `,
    computed: {
        ...Vuex.mapGetters([
            'cart'
        ]),
        freeGifts(){
            return freeGifts
        },
    },
    props: ['product'],
    created() {
    },
    methods: {
        ...Vuex.mapActions([
            'getCart',
            'increaseQty',
            'decreaseQty',
            'removeProduct'
        ])
    }
})


Vue.component('Totals', {
    template: `
        <div class="Minicart__Totals">
            <div class="Minicart__Totals__Item" v-if="cart.original_total_price > 0">
                <div class="Minicart__Totals__Item--Input">
                    <label>Subtotal:</label>
                </div>
                
                <div class="Minicart__Totals__Item--Output">
                    <span class="moneyFormat">{{cart.original_total_price?$options.filters.formatMoney(cart.original_total_price/100) : '✨ GRÁTIS'}}</span>
                </div>
            </div>
            <div class="Minicart__Totals__Item">
                <div class="Minicart__Totals__Item--Input">
                    <label>Cupom: </label>
                    <form @submit.prevent="applyCoupon(Coupons.code)">
                        <input type="text" v-model="Coupons.code" placeholder="digite o código :)" v-if="!Coupons.status">
                    </form>
                </div>
                
                <div class="Minicart__Totals__Item--Output" v-loading="CartState.coupon === 'LOADING'" element-loading-spinner="Minicart__Splash">
                    <a href="#" class="btn" @click="applyCoupon(Coupons.code)" v-if="!Coupons.status">
                        Aplicar
                    </a>
                    <div class="Coupons__List" v-if="Coupons.status">
                        <span class="Coupons__List--Item" v-for="discount in Coupons.appliedDiscounts">
                            <span @click="removeCoupon">
                                <Icon icon="CloseIcon" />
                            </span>
                            <span>
                                {{discount.code}}
                            </span>
                        </span>
                    </div>
                </div>
            </div>
            <div class="Minicart__Totals__Item" v-if="CartState.coupon === 'ERROR'">
                <el-alert
                    type="error">
                    <span v-html="Coupons.error" slot="title"></span>
                </el-alert>
            </div>
            <div class="Minicart__Totals__Item">
                <div class="Minicart__Totals__Item--Input">
                    <label>frete:</label>
                    
                    <form @submit.prevent="getShippingRates" v-if=" Shipping.type ==='Brazil' ">
                        <input type="text" placeholder="digite seu cep :)" v-mask="'#####-###'" v-model="Shipping.zip">
                    </form>
                </div>
                <div class="Minicart__Totals__Item--Output" v-if=" Shipping.type ==='Brazil' " v-loading="CartState.shipping === 'LOADING'" element-loading-spinner="Minicart__Splash">
                    <a href="#" class="btn" @click="getShippingRates">Calcular</a>
                </div>
            </div>
            
            <div class="Minicart__Totals__Item Featured No-Border"  v-if="Shipping.type === 'Global'" v-loading="CartState.shipping === 'LOADING'" element-loading-spinner="Minicart__Splash">
                <span v-if="ShippingRates.length > 0 && GlobalShippingForm === 'CLOSED'">shipping to: {{Shipping.province}} - {{Shipping.zip}}</span>
                <a href="#" class="btn" @click="()=>{setGlobalShippingForm('OPEN');setShipping({rates:[]})}" v-show="ShippingRates.length > 0 && GlobalShippingForm === 'CLOSED'">Change</a>

                <form @submit.prevent="getShippingRates" v-if="ShippingRates.length === 0 || GlobalShippingForm === 'OPEN'">
                    <div class="ShippingLines__List">
                        <select class="ShippingLines__List-Item" v-model="Shipping.country" @change="setShipping({province: null})">
                            <option :value="null">select country</option>
                            <option v-for="(country, index) in ShippingAllCountries" :value="country.name" :selected="index === 0">
                                {{country.country}}
                            </option>
                        </select>
                        <select class="ShippingLines__List-Item" v-model="Shipping.province" placeholder="Select your province" v-if="Shipping.country !== null && GetProvinces !== null">
                            <option :value="null">select province </option>
                            <option v-for="(province, index) in GetProvinces" :value="province.name" :selected="index === 0" >
                                {{ province.name }}
                            </option>
                        </select>
                        <input class="ShippingLines__List-Item" type="text" placeholder="zip code" v-model="Shipping.zip">
                    </div>
                    <a href="#" class="btn" @click="getShippingRates" v-if="Shipping.country && (GetProvinces !== null ? Shipping.province : true) && Shipping.zip">Calculate Shipping</a>
                </form>
            </div>
            
            <div class="Minicart__Totals__Item No-Border"  v-if="ShippingRates.length > 0">
                <ShippingLines :rates="ShippingRates" :type="Shipping.type"/>
            </div>
                
            <div class="Minicart__Totals__Item No-Border"  v-if="CartState.shipping === 'ERROR' && Shipping.type === 'Brazil'">
                <el-alert
                    type="error">
                    <span slot="title">
                        <span>ooops CEP inexistente :( - Não sabe seu CEP? &nbsp;</span><a href="http://www.buscacep.correios.com.br/sistemas/buscacep/buscaCepEndereco.cfm" target="_blank">clique aqui</a>
                    </span>
                </el-alert>
            </div>

            <div class="Minicart__Totals__Item No-Border" v-if="CartState.shipping === 'ERROR' && Shipping.type === 'Global'">
                <div class="Minicart__Totals__Item--ErrorInfo">
                    <p>unable to get this zip code. forgot it? </p><a href="https://worldpostalcode.com/" target="_blank" >click here</a>
                </div>
            </div>

            <div class="Minicart__Totals__Item Featured" v-if="CartTotalDiscounts > 0">
                <div class="Minicart__Totals__Item--Input">
                    <label>descontos ✨:</label>
                </div>
                
                <div class="Minicart__Totals__Item--Output">
                    <span class="moneyFormat">- {{CartTotalDiscounts?$options.filters.formatMoney(CartTotalDiscounts) : '✨ GRÁTIS'}}</span>
                </div>
            </div>
            <div class="Minicart__Totals__Item Featured Main__Info" v-if="CartTotalPrice > 0">
                <div class="Minicart__Totals__Item--Input">
                    <label>total:</label>
                </div>
                
                <div class="Minicart__Totals__Item--Output">
                    <span class="moneyFormat">
                        {{CartTotalPrice?$options.filters.formatMoney(CartTotalPrice) : '✨ GRÁTIS'}}
                    </span>
                </div>
            </div>
            <div class="Minicart__Totals__Item Row" v-if="CartTotalPrice > 0">
                <a :href="CheckoutURL('default')" class="btn btn-checkout">
                    finalizar pedido
                </a>
            </div>
        </div>
    `,
    computed: {
        ...Vuex.mapGetters([
            'CartState',
            'ShippingTypes',
            'Shipping',
            'cart',
            'Coupons'
        ]),
        CartTotalDiscounts(){
            let cartTotalDiscount = this.cart.total_discount? parseFloat(this.cart.total_discount / 100) : 0;
            let DiscountsTotalAmount = this.Coupons.appliedDiscounts ? 
                this.Coupons.appliedDiscounts.reduce(function(prev, cur) {
                    return prev + cur.amount / 100;
                }, 0) : 
                0;
            return cartTotalDiscount + DiscountsTotalAmount
        },
        CartTotalPrice(){
            let CartOriginalTotalPrice = this.cart.original_total_price? parseFloat(this.cart.original_total_price / 100) : 0;
            let ShippingPrice = this.Shipping.shippingRate? parseFloat(this.Shipping.shippingRate.price) : 0;
            let CartTotalDiscounts = this.CartTotalDiscounts? parseFloat(this.CartTotalDiscounts) : 0;

            return (CartOriginalTotalPrice + ShippingPrice) - CartTotalDiscounts
        },
        ShippingRates() {
            let rates = this.Shipping.rates;
            let hasShippingCoupon = false;
            if (this.Coupons && this.Coupons.appliedDiscounts){
                hasShippingCoupon = this.Coupons.appliedDiscounts.filter((coupon)=>{
                    return coupon.type === 'shipping'
                }).length > 0
            };

            rates = hasShippingCoupon ?
                rates.map(rate => {
                    return {
                        ...rate,
                        price: 0
                    }
                }) : 
                rates;
            
            // this.getZipInfos({'zip':this.Shipping.zip,'country':this.Shipping.country})
            return rates
        },
        ShippingAllCountries() {
            let allCountriesOBJ = this.Shipping.allCountries;
            let blockedcountries = ['Brazil', '---']
            let availableCountries = allCountriesOBJ.filter((country) => {
                return !blockedcountries.includes(country.country)
            })
            return availableCountries.map((countryItem) => {
                return {
                    ...countryItem,
                    name: countryItem.country,
                    provinces: countryItem.provinces.length > 0 ? countryItem.provinces.map((provinceItem) => {
                        return {
                            ...provinceItem,
                            name: provinceItem[0]
                        }
                    }) : null
                }
            })
        },
    
        GetProvinces() {
            let SelectedCountryOBJ = this.ShippingAllCountries.filter( ( country ) => {                 
                return country.country === this.Shipping.country
            } )
            
            return SelectedCountryOBJ[0]? SelectedCountryOBJ[0].provinces : null
        }
    },
    props: ['product'],
    data(){
        return{
            GlobalShippingForm: 'OPEN'
        }
    },
    created() {
        // debugger;
        // this.getLocationInfos();
    },
    updated(){
        // this.Shipping.province = this.GetProvinces ? this.GetProvinces[0].name : null
        if (this.Shipping.type === 'Global' && !this.ShippingRates.length > 0) {
            this.setGlobalShippingForm('CLOSED')
        }
    },
    methods: {
        ...Vuex.mapActions([
            'setShipping',
            'getZipInfos',
            'applyCoupon',
            'removeCoupon',
        ]),
        CheckoutURL(env){
            var CheckoutBaseURL = '/checkout'
            if(env === 'prod'){
                CheckoutBaseURL = `https://checkout.oculosshop.com.br/Arrival/${this.cart.token}`
            }
            if(env === 'staging'){
                CheckoutBaseURL = `https://oculosshop-checkout--staging.web.app/Arrival/${this.cart.token}`
            }
            if(env === 'dev'){
                CheckoutBaseURL = `https://oculosshop-checkout--staging.web.app/Arrival/${this.cart.token}`
            }
            if(env === 'local'){
                CheckoutBaseURL = `https://localhost:8080/Arrival/${this.cart.token}`
            }
            if(env === 'default'){
                CheckoutBaseURL = `/checkout`
            }
            return `${CheckoutBaseURL}${this.Coupons.code?`?discount=${this.Coupons.code}`:``}`

        },
        getShippingRates(){
            this.getZipInfos({'type':this.Shipping.type,'zip':this.Shipping.zip,'country':this.Shipping.country,'province':this.Shipping.province})
        },
        setGlobalShippingForm(status){
            this.GlobalShippingForm = status
        },
    }
})
Vue.component('ShippingLines', {
    template: `
        <div class="ShippingLines__List">
            <select class="ShippingLines__List-Item" v-model="Shipping.shippingRate">
                <option v-for="(rate, index) in rates" :value="rate" v-bind:selected="index === 0">
                    {{rate.name}} - {{rate.delivery_days.length>0?rate.delivery_days[0]+' dias úteis - ' : ''}} <span class="moneyFormat">{{rate.price > 0 ? $options.filters.formatMoney(rate.price) : type === 'Brazil'?'✨ GRÁTIS':'✨ FREE'}}</span>
                </option>
            </select>
        </div>
    `,
    computed: {
        ...Vuex.mapGetters([
            'cart',
            'Shipping',
            'Coupons',
        ]),
    },
    props: ['rates','type'],
    created() {
        this.setShipping({
            shippingRate: this.rates[0]
        })
    },
    updated() {
        // console.log('SHIPPINGLINES: updated')
    },
    mounted() {
        // console.log('SHIPPINGLINES: mounted')
    },
    methods: {
        ...Vuex.mapActions([
            'setShipping',
            'getZipInfos'
        ])
    },
    watch: {
        // whenever question changes, this function will run
        rates: function (newRates, oldRates) {
            // console.log('SHIPPINGLINES: change rates')
            // debugger;
            if(JSON.stringify(newRates) !== JSON.stringify(oldRates)){
                this.setShipping({
                    shippingRate: {...newRates[0]}
                })
            }
        }
    },
})

Vue.component('Icon', {
    template: `
        <div class="svg---Wrapper">
            <?xml version="1.0" encoding="UTF-8"?>
            <svg width="20px" height="20px" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" v-if="icon==='MinusIcon'">
                <!-- Generator: Sketch 60.1 (88133) - https://sketch.com -->
                <title>btn qty -</title>
                <desc>Created with Sketch.</desc>
                <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <g id="LineItem" transform="translate(-72.000000, -30.000000)">
                        <g id="CartItem-Inner" transform="translate(12.000000, 9.000000)">
                            <g id="CartItemContent" transform="translate(60.000000, 1.000000)">
                                <g id="qtySelector" transform="translate(1.000000, 17.000000)">
                                    <g id="btn-qty--" transform="translate(0.000000, 4.000000)">
                                        <!-- <circle id="Oval" stroke="#2491c4" cx="9" cy="9" r="9"></circle> -->
                                        <rect id="MinusIcon" fill="#2491c4" x="3" y="8" width="12" height="2"></rect>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </svg>

            <svg width="20px" height="20px" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" v-if="icon==='PlusIcon'">
                <!-- Generator: Sketch 60.1 (88133) - https://sketch.com -->
                <title>btn qty +</title>
                <desc>Created with Sketch.</desc>
                <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <g id="LineItem" transform="translate(-118.000000, -30.000000)">
                        <g id="CartItem-Inner" transform="translate(12.000000, 9.000000)">
                            <g id="CartItemContent" transform="translate(60.000000, 1.000000)">
                                <g id="qtySelector" transform="translate(1.000000, 17.000000)">
                                    <g id="btn-qty-+" transform="translate(46.000000, 4.000000)">
                                        <!-- <circle id="Oval" stroke="#2491c4" cx="9" cy="9" r="9"></circle> -->
                                        <path d="M10,3 L10,8 L15,8 L15,10 L10,10 L10,15 L8,15 L8,10 L3,10 L3,8 L8,8 L8,3 L10,3 Z" id="PlusIcon" fill="#2491c4"></path>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </svg>

            <svg width="154px" height="101px" viewBox="0 0 154 101" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" v-if="icon==='CartEmpty'">
                <!-- Generator: Sketch 60.1 (88133) - https://sketch.com -->
                <title>EmptyIcon@2x</title>
                <desc>Created with Sketch.</desc>
                <g id="Desktop" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round">
                    <g id="Desktop/0-Empty" transform="translate(-1182.000000, -249.000000)" stroke="#2491c4">
                        <g id="Cart-Initial" transform="translate(1080.000000, -1.000000)">
                            <g id="CartEmpty" transform="translate(20.000000, 252.000000)">
                                <g id="EmptyIcon" transform="translate(84.000000, 0.000000)">
                                    <line x1="54.8112583" y1="9" x2="41.8112583" y2="58" id="Stroke-3" stroke-width="2" stroke-dasharray="8.252000000000001,8.252000000000001"></line>
                                    <g id="Group-17" transform="translate(0.811258, 0.000000)">
                                        <path d="M44.9361878,70.1861607 L61.3242358,90.6402273 C62.9294017,92.6436007 64.9770131,94.2525073 67.3076594,95.3421407 L67.4566594,95.4126273 C72.1094934,97.5886607 77.5099301,97.5246407 82.1094105,95.238674 C84.1713362,94.2137073 85.9990262,92.778754 87.4779651,91.0204673 L105.25386,69.8977473" id="Stroke-5" stroke-width="2" stroke-dasharray="9.553000000000001,9.553000000000001"></path>
                                        <line x1="106.682308" y1="57.129702" x2="91.3977712" y2="6.04303533" id="Stroke-9" stroke-width="2" stroke-dasharray="8.676,8.676"></line>
                                        <path d="M0,0.565316 L0,23.8155693 C0,29.5224027 2.7470655,34.8845627 7.39079039,38.2407627 L33.9453231,57.434476 C35.1666026,58.3178227 36.2629563,59.3602493 37.2038035,60.534596 L61.3242358,90.6401627 C62.9294017,92.643536 64.9770131,94.2524427 67.3076594,95.342076 L67.4566594,95.4125627 C72.1094934,97.588596 77.5099301,97.524576 82.1094105,95.2386093 C84.1713362,94.2136427 85.9990262,92.7786893 87.4779651,91.0204027 L113.917983,59.601456 C114.746917,58.6165827 115.688415,57.729356 116.722306,56.9585293 L141.424424,38.5453427 C146.193725,34.990616 149,29.4118227 149,23.4870627 L149,0.565316 L0,0.565316 Z" id="Stroke-15" stroke-width="4" stroke-dasharray="9"></path>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </svg>
            
            <svg width="14px" height="28px" viewBox="0 0 14 28" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" v-if="icon==='ArrowNext'">
                <!-- Generator: Sketch 60.1 (88133) - https://sketch.com -->
                <title>ArrowNext</title>
                <desc>Created with Sketch.</desc>
                <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <g id="Bundle/Primary" transform="translate(-322.000000, -41.000000)" fill="#2491c4" fill-rule="nonzero">
                        <g id="Bundle">
                            <g id="/ArrowNext" transform="translate(329.000000, 55.000000) rotate(-180.000000) translate(-329.000000, -55.000000) translate(322.000000, 41.000000)">
                                <path d="M13.3581147,27.1252335 C13.2486476,27.1259203 13.1432591,27.0818935 13.0644434,27.0025501 L0.105145814,13.8579039 C-0.0401029378,13.6862234 -0.034194972,13.4266625 0.118700668,13.2623841 C0.271596308,13.0981057 0.519856704,13.084576 0.688293228,13.2313424 L13.6475908,26.3759887 C13.7711134,26.5003251 13.8097063,26.6906791 13.7450379,26.8566327 C13.6803695,27.0225863 13.5254711,27.1306981 13.3539194,27.1296231 L13.3581147,27.1252335 Z" id="Path"></path>
                                <path d="M0.422080574,14.1296231 C0.250528871,14.1306981 0.0956305179,14.0225863 0.0309621069,13.8566327 C-0.0337063041,13.6906791 0.00488659761,13.5003251 0.128409215,13.3759887 L13.0877068,0.231342398 C13.2561433,0.0845759858 13.5044037,0.0981056932 13.6572993,0.262384081 C13.810195,0.426662469 13.8161029,0.686223406 13.6708542,0.857903869 L0.711556628,14.0025501 C0.63445165,14.0824436 0.530683675,14.1279924 0.422080574,14.1296231 Z" id="Path"></path>
                            </g>
                        </g>
                    </g>
                </g>
            </svg>
            
            <svg width="14px" height="28px" viewBox="0 0 14 28" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"  v-if="icon==='ArrowPrev'">
                <!-- Generator: Sketch 60.1 (88133) - https://sketch.com -->
                <title>ArrowPrev</title>
                <desc>Created with Sketch.</desc>
                <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <g id="Bundle/Primary" transform="translate(0.000000, -41.000000)" fill="#2491c4" fill-rule="nonzero">
                        <g id="Bundle">
                            <g id="/ArrowPrev" transform="translate(0.000000, 41.000000)">
                                <path d="M13.3581147,27.1114963 C13.2486476,27.1121831 13.1432591,27.0681562 13.0644434,26.9888129 L0.105145814,13.8441666 C-0.0401029378,13.6724862 -0.034194972,13.4129252 0.118700668,13.2486468 C0.271596308,13.0843685 0.519856704,13.0708388 0.688293228,13.2176052 L13.6475908,26.3622514 C13.7711134,26.4865879 13.8097063,26.6769419 13.7450379,26.8428955 C13.6803695,27.0088491 13.5254711,27.1169609 13.3539194,27.1158859 L13.3581147,27.1114963 Z" id="Path"></path>
                                <path d="M0.422080574,14.1158859 C0.250528871,14.1169609 0.0956305179,14.0088491 0.0309621069,13.8428955 C-0.0337063041,13.6769419 0.00488659761,13.4865879 0.128409215,13.3622514 L13.0877068,0.217605166 C13.2561433,0.0708387543 13.5044037,0.0843684618 13.6572993,0.24864685 C13.810195,0.412925238 13.8161029,0.672486175 13.6708542,0.844166638 L0.711556628,13.9888129 C0.63445165,14.0687064 0.530683675,14.1142551 0.422080574,14.1158859 Z" id="Path"></path>
                            </g>
                        </g>
                    </g>
                </g>
            </svg>

            <svg width="9px" height="7px" viewBox="0 0 9 7" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"  v-if="icon==='CloseIcon'">
                <!-- Generator: Sketch 60.1 (88133) - https://sketch.com -->
                <title>CLOSE</title>
                <desc>Created with Sketch.</desc>
                <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="square">
                    <g id="DiscountCoupon" transform="translate(-12.000000, -15.000000)" stroke="#FFF7FA">
                        <g id="Button-Secondary">
                            <g id="CLOSE" style="cursor: pointer;" transform="translate(16.192388, 18.192388) rotate(-315.000000) translate(-16.192388, -18.192388) translate(11.192388, 13.192388)">
                                <path d="M9.93502884,5 L0.935028843,5 M5.43502884,9.5 L5.43502884,0.5" id="Combined-Shape"></path>
                            </g>
                        </g>
                    </g>
                </g>
            </svg>
        </div>
    `,
    computed: {
        ...Vuex.mapGetters([
            'cart'
        ])
    },
    props: ['icon'],
    created() {
        // debugger;
        // this.getCart();
    },
    methods: {
        ...Vuex.mapActions([
            'getCart',
            'clearCart'
        ])
    }
})

const MinicartStore = new Vuex.Store({
    state: {
        EvolveAPI: {
            BaseURL: 'https://evolvehub.azurewebsites.net/api/',
            AccessToken : sessionStorage.getItem("EvolveToken"),
            Credentials: {
                apiKey: '915318c9c83ff495d3ff29cd27fdb0da',
                password: '0E0b21E4784463ecdea25f10b7468b@4'
            }
        },
        CartState:{
            product: 'IDLE',
            bundles: 'IDLE',
            shipping: 'IDLE',
            coupon: 'IDLE'
        },
        Shipping: {
            allCountries: window.EvolveHUB.ShopifyShippingCountries,
            freeShippingValue: window.EvolveHUB.FreeShippingValue,
            type: 'Brazil',
            zip: null,
            country: null,
            province: null,
            shippingRate: null,
            rates:[]
        },
        InventoryIncomings: null,
        Totals:{
            products: 0,
            shipping: 0,
            discounts: 0,
            total: 0,
        },
        ShippingTypes:[{
          value: 'Brazil',
          label: '🇧🇷'
        },  {
          value: 'Global',
          label: '🌍'
        }],
        cart: null,
        Coupons: {
            code: window.EvolveHUB.ShopifyAutomaticDiscountCoupon || null,
            status:null,
            appliedDiscounts:null
        },
        bundles: null,
        customer: window.EvolveHUB.ShopifyCustomerOBJ || {},
        Promo_count: EvolveStorage.get('promoAppplieanceCount') || 0
    },
    getters: {
        CartState: state => {

            return state.CartState
        },
        cart: state => {
            return state.cart
        },
        Totals: state => {
            return state.Totals
        },
        Coupons: state => {
            return state.Coupons
        },
        customer: state => {
            return state.customer
        },
        bundles: state => {
            return state.bundles
        },
        Shipping: state => {
            return state.Shipping
        },
        ShippingTypes: state => {
            return state.ShippingTypes
        },
        InventoryIncomings: (state) => {
            return state.InventoryIncomings
        },
        Promo_count: state => {
            return state.Promo_count
        }
    },
    actions: {
        async setStorageItem({commit, dispatch, rootState}, payload){
            let $this = this;
            EvolveStorage.set(payload.property, payload.value)
        },
        async deleteStorageItem({commit, dispatch, rootState}, payload){
            let $this = this;
            EvolveStorage.delete(payload.property)
        },
        async Auth({commit, dispatch, rootState}){
            let $this = this;
            await EvolveAPI.post('/AuthApi/Authorize', JSON.stringify(rootState.EvolveAPI.Credentials))
                .then(response => {
                    sessionStorage.setItem("EvolveToken", response.data.data.accessToken)
                    commit('SetAccessToken', response.data.data.accessToken)
                })
                .catch((error) => {
                    console.log('Error Auth')
                });
        },
        
        async getCart({ state, commit, dispatch, rootState }) {
            let Coupons = rootState.Coupons
            commit('setCartState',{product:'LOADING'})
            return new Promise((resolve, reject) => {

                axios.get('/cart.js', {})
                    .then(response => {
                        let cartResponse = response.data;
                        EvolveCore._helpers.triggerEvent(`cart:updated`, cartResponse)

                        cartResponse = EvolveCore.setCartValidations(cartResponse)
                        let triggerEvolveFunctions = () =>{
                            if(cartResponse.items.length > 0){
                                dispatch('getBundles')
                            }
                            if(state.Shipping.zip){
                                dispatch('getZipInfos', {'type':state.Shipping.type,'zip':state.Shipping.zip,'country':state.Shipping.country,'province':state.Shipping.province})
                            }
                        }
                        
    
                        if(Coupons.code && cartResponse.items.length > 0){
                            dispatch('applyCoupon', Coupons.code).then(() => {
                                commit('setCart', cartResponse)
                                commit('setCartState',{product:'IDLE'})
                                if(!rootState.EvolveAPI.AccessToken){
                                    dispatch('Auth')
                                        .then(() => {
                                            triggerEvolveFunctions();
                                        })
                                } else {        
                                    triggerEvolveFunctions();
                                }
                            })
                        } else{
                            commit('setCart', cartResponse)
                            commit('setCartState',{product:'IDLE'})
                            if(!rootState.EvolveAPI.AccessToken){
                                dispatch('Auth')
                                    .then(() => {
                                        triggerEvolveFunctions();
                                    })
                            } else {        
                                triggerEvolveFunctions();
                            }
                        }
                        
                        return resolve(cartResponse)
                    })
                    .catch((e) => {
                        console.error(e)
                        commit('setCartState',{product:'IDLE'})
                        console.info('Error getCart')
                        return reject(new Error (`Erro ao recuperar o carrinho.`))
                    })
            })
            
        },
        async getProductDetails({ state, commit, dispatch }) {
            state.cart.items.map((item)=>{
                axios.get(`/products/${item.handle}?view=json`, {})
                    .then(response => {
                        let prodDetails = response.data
                        return commit('setProductDetails', {'handle':item.handle, 'details': prodDetails})
                        // console.log(prodDetails)
                    })
                    .catch((e) => {
                        console.error(e)
                        return commit('setProductDetails', {'handle':item.handle, 'details': {}})
                    })
            })
        },

        buildEvolveCartOBJ({ rootState }) {
            let cart = rootState.cart;
            let customer = rootState.customer;
            let EvolveCartOBJ = {};

            EvolveCartOBJ.customer = customer.id ? {
                email: customer.email,
                tags: customer.tags.split(', '),
                ordersCount: parseInt(customer.orders_count),
            }:{
                email: null,
                tags: null,
                ordersCount: 0,
            }
            EvolveCartOBJ.lineItems = cart.items.map((lineItem)=>{
                return {
                    id: lineItem.product_id,
                    variantId: lineItem.id,
                    type:lineItem.product_type,
                    quantity: lineItem.quantity
                }
            });
            EvolveCartOBJ.subTotal = parseFloat(cart.original_total_price / 100) || 0;
            EvolveCartOBJ.totalDiscount = parseFloat(cart.total_discount / 100) || 0;
            EvolveCartOBJ.totalPrice = parseFloat(cart.total_price / 100) || 0;
            
            return EvolveCartOBJ;
        },
        getBundles({ commit, dispatch, state }) {
            commit('setCartState',{bundles:'LOADING'})
            // commit('setBundles', null)
            return new Promise((resolve, reject) => {
                let request = dispatch('buildEvolveCartOBJ').then(EvolveCartOBJ => {
                    EvolveAPI.post('/CartRecommendations', EvolveCartOBJ)
                        .then(response => {
                            let Bundles = response.data
                            // Bundles = bundleMock;
                            let enabledBundles = Bundles ? Object.keys(Bundles).map(type =>{return Bundles[type]}).flat().filter(bundle => bundle.allowAddToCart && bundle.allowAddToCart === true) : []
                            enabledBundles = enabledBundles.map((bundle) => {
                                bundle.products.map((product) => {
                                    product.inventoryQty = product.variants.reduce(function (a, b) {
                                        return b['inventoryQty'] == null ? a : a + b['inventoryQty'];
                                    }, 0);
                                    return product
                                })
                                bundle.products = bundle.products.filter((product) => {
                                    return product
                                })
                                bundle.inventoryQty = bundle.products.reduce(function (a, b) {
                                    return b['inventoryQty'] == null ? a : a + b['inventoryQty'];
                                }, 0)
                                return bundle
                            }).filter((bundle) => {
                                // return bundle.inventoryQty > 0
                                return bundle
                            });
                            enabledBundles = enabledBundles.length > 0 ? enabledBundles.filter((bundle)=>{
                                return (bundle.activeVariantsCount === undefined || bundle.activeVariantsCount > 0)
                            }):[]
                            
                            if(enabledBundles.length > 0){
                                let ProductsToAdd = enabledBundles.map(bundleAllowed => {
                                    return {
                                        variant:{
                                            key: bundleAllowed.products[0].variants[0]._id
                                        },
                                        amount:1
                                    }
                                })

                                dispatch('addProduct', ProductsToAdd)
                            }
                            commit('setBundles', response.data)
                            commit('setCartState',{bundles:'IDLE'})
                        })
                        .catch((e) => {
                            console.error(e)
                            if(e.response.status === 401){
                                dispatch('Auth')
                                    .then(() => {
                                        dispatch('getBundles')
                                    })
                            } else {
                                commit('setCartState',{bundles:'IDLE'})
                                console.info('Error getBundles')
                            }
                        })
                });
            })
        },
        async clearCart({ commit, dispatch }) {
            await axios.get('/cart/clear.js', {})
                .then(response => {
                    dispatch('getCart')
                })
                .catch((e) => {
                    console.error(e)
                    // commit('SetIncomings', null, 'ERROR')
                    console.info('Error clearCart')
                })
        },
        
        async decreaseQty({ commit, dispatch }, lineItemsARR) {
            let changeQtyOBJ = {};
            changeQtyOBJ['lineItems'] = lineItemsARR
            changeQtyOBJ['operation'] = 'subtract'
            dispatch('changeLineItemQty', changeQtyOBJ)
        },
        async increaseQty({ commit, dispatch }, lineItemsARR) {
            let changeQtyOBJ = {};
            changeQtyOBJ['lineItems'] = lineItemsARR
            changeQtyOBJ['operation'] = 'sum'
            dispatch('changeLineItemQty', changeQtyOBJ)
        },
        async addProduct({ commit, dispatch }, lineItemsARR) {
            let changeQtyOBJ = {};
            changeQtyOBJ['lineItems'] = lineItemsARR
            changeQtyOBJ['operation'] = 'set'
            dispatch('setLineItemQty', changeQtyOBJ)
        },
        async removeProduct({ commit, dispatch }, lineItemsARR) {
            return new Promise((resolve, reject) => {
                let changeQtyOBJ = {};
                changeQtyOBJ['lineItems'] = lineItemsARR
                changeQtyOBJ['operation'] = 'set'
                dispatch('setLineItemQty', changeQtyOBJ).then(()=>{
                    resolve()
                })
            });
        },
        async setLineItemQty({ commit, dispatch }, changeQtyOBJ) {
            var qtyOBJ = new Object()
            let lineItemsOBJ = changeQtyOBJ.lineItems.map((lineItem)=>{
                switch (changeQtyOBJ.operation) {
                    case 'sum':
                        qtyOBJ[lineItem.variant.key] = lineItem.variant.quantity + lineItem.amount
                        break;
                    case 'subtract':
                        qtyOBJ[lineItem.variant.key] = lineItem.variant.quantity - lineItem.amount
                        break;
                    default:
                        qtyOBJ[lineItem.variant.key] = lineItem.amount
                        break;
                }
                return qtyOBJ
            })
            dispatch('updateLineItem',qtyOBJ)
        },
        async changeLineItemQty({ commit, dispatch }, changeQtyOBJ) {
            var qtyOBJ = new Object()
            let lineItemsOBJ = changeQtyOBJ.lineItems.map((lineItem)=>{
                qtyOBJ['id'] = lineItem.variant.key
                switch (changeQtyOBJ.operation) {
                    case 'sum':
                        qtyOBJ['quantity'] = lineItem.variant.quantity + lineItem.amount
                        break;
                    case 'subtract':
                        qtyOBJ['quantity'] = lineItem.variant.quantity - lineItem.amount
                        break;
                    default:
                        qtyOBJ['quantity'] = lineItem.amount
                        break;
                }
                return qtyOBJ
            })
            dispatch('changeLineItem',qtyOBJ)
        },
        async changeLineItem({ commit, dispatch }, updateItemsArray) {
            let request = updateItemsArray
            await axios.post('/cart/change.js', request)
                .then(response => {
                    dispatch('getCart')
                })
                .catch((e) => {
                    console.error(e)
                    console.info('Error updateLineItem')
                })
        },
        async updateLineItem({ commit, dispatch }, updateItemsArray) {
            let request = {}
            request.updates = updateItemsArray;
            debugger;
            await axios.post('/cart/update.js', request)
                .then(response => {
                    dispatch('getCart')
                })
                .catch((e) => {
                    console.error(e)
                    console.info('Error updateLineItem')
                })
        },
        setShipping({ commit }, infos){
            commit('setShipping',
                {
                    ...infos
                }
            )
        },
        async getZipInfosBrazil ({ commit, dispatch, rootState },zip) {
            zip.length === 8 &&
                await axios.get('https://viacep.com.br/ws/' + zip + '/json/')
                    .then(function (response) {
                        response.data.estado = null
                        switch (response.data.uf) { 
                            case 'AC' : response.data.estado = 'Acre'; break; 
                            case 'AL' : response.data.estado = 'Alagoas'; break; 
                            case 'AP' : response.data.estado = 'Amapá'; break; 
                            case 'AM' : response.data.estado = 'Amazonas'; break; 
                            case 'BA' : response.data.estado = 'Bahia'; break; 
                            case 'CE' : response.data.estado = 'Ceará'; break; 
                            case 'DF' : response.data.estado = 'Distrito Federal'; break; 
                            case 'ES' : response.data.estado = 'Espírito Santo'; break; 
                            case 'GO' : response.data.estado = 'Goiás'; break; 
                            case 'MA' : response.data.estado = 'Maranhão'; break; 
                            case 'MT' : response.data.estado = 'Mato Grosso'; break; 
                            case 'MS' : response.data.estado = 'Mato Grosso do Sul'; break; 
                            case 'MG' : response.data.estado = 'Minas Gerais'; break; 
                            case 'PA' : response.data.estado = 'Pará'; break; 
                            case 'PB' : response.data.estado = 'Paraíba'; break; 
                            case 'PR' : response.data.estado = 'Paraná'; break; 
                            case 'PE' : response.data.estado = 'Pernambuco'; break; 
                            case 'PI' : response.data.estado = 'Piauí'; break; 
                            case 'RJ' : response.data.estado = 'Rio de Janeiro'; break; 
                            case 'RN' : response.data.estado = 'Rio Grande do Norte'; break; 
                            case 'RS' : response.data.estado = 'Rio Grande do Sul'; break; 
                            case 'RO' : response.data.estado = 'Rondônia'; break; 
                            case 'RR' : response.data.estado = 'Roraima'; break; 
                            case 'SC' : response.data.estado = 'Santa Catarina'; break; 
                            case 'SP' : response.data.estado = 'São Paulo'; break; 
                            case 'SE' : response.data.estado = 'Sergipe'; break; 
                            case 'TO' : response.data.estado = 'Tocantins'; break; default : $estado = 'Não informado.'; break; 
                        }
                        commit('setShipping',
                            {
                                'country': 'Brazil',
                                'province': response.data.estado,
                            }
                        )
                        return response.data;
                    })
                    .catch(function (error) {
                        console.log(error)
                    })
                    .finally(function () {})
        },
        async getZipInfosUS ({ commit, dispatch, rootState },zip) {
            zip.length === 5 &&
                await axios.get(`http://api.zippopotam.us/us/${zip}`)
                    .then(function (response) {
                        commit('setShipping',
                            {
                                'country': 'United States',
                                'province': response.data.places[0].state,
                            }
                        )
                        return response.data;
                    })
                    .catch(function (error) {
                        console.log(error)
                    })
                    .finally(function () {})
        },
        getZipInfos ({ commit, dispatch, rootState },payload) {
            const $this = this
            let zip = payload.zip.replace(/\D/g, '')

            commit('setCartState',{shipping:'LOADING'})

            switch (payload.type) {
                    case 'Brazil':
                        dispatch('getZipInfosBrazil', zip)
                            .then(response => {
                                dispatch('getShippingLines', {
                                    zip: rootState.Shipping.zip,
                                    country: rootState.Shipping.country,
                                    province: rootState.Shipping.province
                                })
                            }, (error) => {
                                commit('setCartState',{shipping:'ERROR'})
                                console.info('Erro ao calcular cep, por favor tente novamente :)')
                            })
                    break;
                    case 'United States':
                        dispatch('getZipInfosUS', zip)
                            .then(response => {
                                dispatch('getShippingLines', {
                                    zip: rootState.Shipping.zip,
                                    country: rootState.Shipping.country,
                                    province: rootState.Shipping.province
                                })
                            }, (error) => {
                                console.info('Error at shipping calculation, please try again :)')
                            })
                    break;
                default:
                    dispatch('getShippingLines', {
                        zip: rootState.Shipping.zip,
                        country: rootState.Shipping.country,
                        province: rootState.Shipping.province
                    })
                    break;
            }
        },
        getShippingLines({ commit, dispatch }, payload) {
            let request = payload;
            let serialize = function(obj, prefix) {
                var str = [],
                    p;
                for (p in obj) {
                    if (obj.hasOwnProperty(p)) {
                    var k = prefix ? prefix + "[" + p + "]" : p,
                        v = obj[p];
                    str.push((v !== null && typeof v === "object") ?
                        serialize(v, k) :
                        encodeURIComponent(k) + "=" + encodeURIComponent(v));
                    }
                }
                return str.join("&");
            }
            commit('setCartState',{shipping:'LOADING'})
            commit('setShipping',{'rates': [], 'error': false})
            
            axios.get('/cart/shipping_rates.json?'+serialize({shipping_address:request}))
                .then(response => {
                    commit('setShipping',   
                        {
                            'rates': response.data.shipping_rates
                        }
                    )
                    commit('setCartState',{shipping:'IDLE'})
                    sessionStorage.setItem('ZipCode', response.data.shipping_rates);
                })
                .catch((e) => {
                    console.error(e)
                    commit('setCartState', {'shipping': 'ERROR'})
                    console.log('Erro ao calcular o frete, verfique seu CEP e tente novamente')
                })
        },
        async GetInventoryIncomings ({ commit, dispatch }) {
            
            return new Promise((resolve, reject) => {
                console.log('OLHAAAA')
                EvolveAPI.get('/InventoryIncomings').then(response => {
                    commit('SetInventoryIncomings', response.data)
                    resolve(response.data)
                }).catch(err => {
                    reject(new Error(`GetIncomings: ${err.message}`))
                })
            })
            
            
            
        },
        GetInventoryIncoming ({ state, commit, dispatch }, id) {
            return new Promise((resolve, reject) => {
                if(!state.InventoryIncomings){
                    dispatch('GetInventoryIncomings')
                        .then(function(incomings) {
                            return incomings;
                        })
                        .then(function(InventoryIncomings) {
                            var foundInventories = InventoryIncomings.filter(function(incoming){
                                return parseInt(incoming.partnerId) === id;
                            })
                            resolve(foundInventories[0] || null)
                        });
                } else{
                    var foundInventories = state.InventoryIncomings.filter(function(incoming){
                        return parseInt(incoming.partnerId) === id;
                    })
                    resolve(foundInventories[0] || null)
                }
            })
        },
        async BuildShippingRates({ state, commit, dispatch }, methodOBJ){
            let incomings = state.InventoryIncomings;
            let range = methodOBJ.delivery_days;
            let cartProducts = state.cart.items.map((item)=>{
                console.log('dispatch')
                return dispatch('GetInventoryIncoming', item.variant_id).then((incoming)=>{
                    // var sinceDate = incoming ? moment(incoming.incomingDate).format("DD/MMM") : null
                    // var sinceDate = incoming ? moment(incoming.incomingDate).format("DD/MMM") : null
                    var sinceDate = incoming ? EvolveCore._helpers.dateFormat(incoming.incomingDate) : null
                    var minEstimatedDays = range[0] - 2
                    var maxEstimatedDays = range[1] + 0
                    
                    minEstimatedDays = minEstimatedDays > 0 ? minEstimatedDays : 0
                    maxEstimatedDays = maxEstimatedDays > 0 ? maxEstimatedDays : 0

                    var deliveryMessage = `
                        ${minEstimatedDays !== maxEstimatedDays
                        ? `${minEstimatedDays > 0? `De ${minEstimatedDays} a`: 'Até'} ${maxEstimatedDays === 1 ? `${maxEstimatedDays} dia útil` : `${maxEstimatedDays} dias úteis`} `
                        : `Até ${maxEstimatedDays === 1 ? `${maxEstimatedDays} dia útil` : `${maxEstimatedDays} dias úteis`}`} 
                        ${sinceDate ? `a partir de ${sinceDate}` : ``}
                    `
                    commit('setProductDeliveryMessage', {'handle':item.handle, 'delivery_message': deliveryMessage.trim()})
                    return item
                })
            })
            await Promise.all(cartProducts).then(function(productsWithMessage) {
                // commit('setCart', {
                //     items: productsWithMessage
                // })
            })
        },
        readCouponFromCheckout({ state, commit, dispatch }, {checkout, coupon}) {
            let couponToValidate = coupon;
            coupon = coupon?coupon.toLowerCase():null;
            return new Promise((resolve, reject) => {
                const getParents = function (elem) {
                    var parents = [];
                    for ( ; elem && elem !== document; elem = elem.parentNode ) {parents.push(elem);}
                    return parents;
                };
                const parentClasses = (selector) => {
                    return getParents(selector).map((item)=>{return item.className?item.className.split(' '):null}).flat()
                }

                const parser = new DOMParser();
                const htmlDocument = parser.parseFromString(checkout, "text/html");
                let CheckoutInfos = Array.from(htmlDocument.querySelectorAll('script')).filter(function(script){
                    return script.text.indexOf('Shopify = window.Shopify || {}') > -1
                })[0].text
                // let CheckoutOBJ = {}
                // CheckoutOBJ.Checkout = {}
                // var ShopifyKey = new RegExp(/Shopify\b/, 'g');
                // var WindowKey = new RegExp(/window.\b/, 'g');
                // CheckoutInfos = CheckoutInfos.replace(ShopifyKey, 'CheckoutOBJ');
                // CheckoutInfos = CheckoutInfos.replace(WindowKey, '');
                
                var parseCheckoutOBJ = new Function (CheckoutInfos);
                parseCheckoutOBJ()

                if(Shopify.Checkout.page === 'stock_problems'){
                    let productsToRemove = htmlDocument.querySelectorAll('.product__status')[0].parentNode.querySelectorAll('.product__description')[0].innerHTML.trim()
                    commit('setCartState',{coupon:'ERROR'})
                    commit('setCoupons',{
                        error: `O produto ${productsToRemove} está esgotado, remova-o e tente novamente`
                    })
                    console.info(`O produto ${productsToRemove} está esgotado, remova-o e tente novamente`)
                    return resolve()
                }


                const couponDiscountSelector = htmlDocument.querySelectorAll('.reduction-code__text');
                const couponDiscountTarget = couponDiscountSelector[couponDiscountSelector.length-1];
                const hasCoupon = (couponDiscountTarget && parentClasses(couponDiscountTarget).includes('order-summary__section--total-lines')) || (couponDiscountTarget && parentClasses(couponDiscountTarget).includes('order-summary__section--discount')) ? true : false;
                const hasErrorCoupon = htmlDocument.querySelectorAll('#error-for-reduction_code').length > 0 ? true : false;

                let hasPreviousCouponApplied = false;

                let couponDiscountAppliesTo = null;
                let couponDiscountCode = null;
                let couponDiscountType = htmlDocument.querySelectorAll('[data-discount-type]')[0] ? htmlDocument.querySelectorAll('[data-discount-type]')[0].dataset.discountType : null;
                let couponDiscountAmount = htmlDocument.querySelectorAll('[data-checkout-discount-amount-target]')[0] ? parseInt(htmlDocument.querySelectorAll('[data-checkout-discount-amount-target]')[0].dataset.checkoutDiscountAmountTarget) : null;
                
                let lineItemCoupons = htmlDocument.querySelectorAll('.order-summary__section--product-list .reduction-code__text');
                let lineItemCouponsApplied = [];
                for (i = 0; i < lineItemCoupons.length; ++i) {
                    var e = lineItemCoupons[i]
                    lineItemCouponsApplied.push(e.innerText.trim().split('(-')[0].replace(')', '').toLowerCase().trim())
                }
                if(hasCoupon){
                    couponDiscountCode = couponDiscountSelector[couponDiscountSelector.length-1].innerText.trim().toLowerCase();
                    if(lineItemCouponsApplied.length > 0 && lineItemCouponsApplied.indexOf(coupon) > -1)  {
                        couponDiscountAppliesTo = 'line_item';
                        couponDiscountType = 'amount';
                        couponDiscountAmount = 0;
                        _foundCouponAmout = false
                        for (i = 0; i < couponDiscountSelector.length; ++i) {
                            var e = couponDiscountSelector[i]
                            if(!_foundCouponAmout){
                                if(coupon === couponDiscountCode && e.innerText.trim().toLowerCase().indexOf(couponDiscountCode)>-1){
                                    var couponValueFormatted = e.innerText.trim().split('(-')[1].replace(')', '')
                                    couponDiscountAmount = parseFloat((MinicartStore._vm.$options.filters.unformatMoney(couponValueFormatted)));
                                    couponDiscountAmount = parseFloat((couponDiscountAmount).toFixed(2));
                                    _foundCouponAmout = true;
                                }
                            }
                        }
                        // couponDiscountAmount = parseFloat((MinicartStore._vm.$options.filters.unformatMoney(htmlDocument.querySelectorAll('.order-summary__section--total-lines [data-checkout-subtotal-price-target]')[0].innerText) - MinicartStore._vm.$options.filters.unformatMoney(htmlDocument.querySelectorAll('.total-recap .total-recap__final-price')[0].innerText)).toFixed(2)) > 0 ? parseFloat((MinicartStore._vm.$options.filters.unformatMoney(htmlDocument.querySelectorAll('.order-summary__section--total-lines [data-checkout-subtotal-price-target]')[0].innerText) - MinicartStore._vm.$options.filters.unformatMoney(htmlDocument.querySelectorAll('.total-recap .total-recap__final-price')[0].innerText)).toFixed(2)) : null;
                        console.log(`couponDiscountAmount ${couponDiscountAmount}`)
                    } else if(parentClasses(couponDiscountTarget).includes('order-summary__section--total-lines')) {
                        couponDiscountAppliesTo = 'order';
                        couponDiscountCode = couponDiscountSelector[couponDiscountSelector.length-1].innerText.trim().toLowerCase();
                        couponDiscountType = htmlDocument.querySelectorAll('[data-discount-type]')[0] ? htmlDocument.querySelectorAll('[data-discount-type]')[0].dataset.discountType : null;
                        couponDiscountAmount = htmlDocument.querySelectorAll('[data-checkout-discount-amount-target]')[0] ? parseInt(htmlDocument.querySelectorAll('[data-checkout-discount-amount-target]')[0].dataset.checkoutDiscountAmountTarget) : null;
                    } else {
                        couponDiscountAppliesTo = null;
                        couponDiscountType = null;
                        couponDiscountAmount = null;
                    }
                    hasPreviousCouponApplied =  couponDiscountCode === coupon || htmlDocument.querySelector('[data-step]').getAttribute('data-step') === 'stock_problems'? false : true
                }


                if(hasCoupon && !hasErrorCoupon){
                    if(!hasPreviousCouponApplied){
                        dispatch('setStorageItem', {
                            property: 'discount_coupon',
                            value: couponDiscountCode
                        })

                        commit('setCoupons',{
                            code: couponDiscountCode,
                            status: hasCoupon,
                            appliedDiscounts:[
                                {
                                    code: couponDiscountCode,
                                    type: couponDiscountType,
                                    amount: couponDiscountAmount,
                                }
                            ],
                        })
                        resolve(couponDiscountCode)
                    } else {
                        if(couponDiscountAppliesTo !== 'line_item'){
                            dispatch('removeCoupon').then(()=>{
                                dispatch('applyCoupon', couponDiscountCode)
                            })
                        }
                    }
                } else {
                    // debugger;
                    dispatch('deleteStorageItem', {
                        property: 'discount_coupon'
                    })
                    commit('setCoupons',{
                        code: null,
                        status: null,
                        appliedDiscounts: null,
                    })
                    if(coupon && coupon !== " "){
                        console.warn(`O código ${coupon} não é aplicável para seu carrinho.`)
                        commit('setCartState',{coupon:'ERROR'})
                        commit('setCoupons',{
                            error: `O código <b>${coupon}</b> não é aplicável para seu carrinho.`
                        })

                        if(coupon === promoCoupon){
                            // dispatch('removeProduct',[{'variant':{key: promoProdID}, 'amount':0}])
                        }
        
                        return reject(new Error (`O código ${coupon} não é aplicável para seu carrinho.`))
                    } else {
                        commit('setCartState',{coupon:'IDLE'})
                    }
                    return resolve()
                }
                commit('setCartState',{coupon:'IDLE'})
            })
        },
        async removeCoupon({ commit, dispatch }) {
            return new Promise((resolve, reject) => {
                dispatch('applyCoupon', " ").then(() => {
                    // debugger;
                    dispatch('deleteStorageItem', {
                        property: 'discount_coupon'
                    })
                    commit('setCoupons',{
                        code: null,
                        status: null,
                        appliedDiscounts: null,
                    })
                    dispatch('getCart')
                    resolve()
                })
            })
        },
        applyCoupon({ state, commit, dispatch }, coupon) {
            let couponToValidate = coupon;
            commit('setCartState',{coupon:'LOADING'})
            // if(couponToValidate === promoCoupon && state.Promo_count > 0){
            //     return dispatch('setPromo_count', 0).then(()=>{
            //         dispatch('getBundles')
            //     })
            // }
            console.log(`applying coupon: '${couponToValidate}'`)
            return new Promise((resolve, reject) => {
                axios.get(`/checkout?discount=${encodeURI(coupon)}`)
                    .then(response => {
                        dispatch('readCouponFromCheckout',{checkout:response.data, coupon:coupon}).then(()=>{
                            resolve()
                        })
                    })
                    .catch((e) => {
                        console.error(e)    
                    })
                    .finally(()=>{
                        resolve()
                    })
                // if(!state.Coupons.appliedDiscounts || state.Coupons.appliedDiscounts.filter((discount)=>{return discount.code.toLowerCase() === couponToValidate.toLowerCase()}).length === 0){
                // } else {
                //     commit('setCartState',{coupon:'IDLE'})
                //     resolve()
                // }
            })
        },
        getAppliedCoupon({ state, commit, dispatch }, coupon) {
            commit('setCartState',{coupon:'LOADING'})
            return new Promise((resolve, reject) => {
                axios.get(`/checkout`)
                    .then(response => {
                        dispatch('readCouponFromCheckout',{checkout:response.data}).then((coupon)=>{
                            resolve(coupon)
                        })
                    })
                    .catch((e) => {
                        console.error(e)    
                    })
            })
        },
        async setPromo_count({ commit }, value) {
            await commit('setPromo_count', value)
        },
        async setTotals({ commit }, totals) {
            await commit('setTotals', totals)
        },
        async setCart({ commit }, value) {
            await commit('setCart', value)
        },

    },
    mutations: {
        SetAccessToken: function (state, token) {
            state.EvolveAPI.AccessToken = token
        },
        setCartState: function (state, CartStateOBJ) {
            // state.CartState = CartStateOBJ
            state.CartState = {
                ...state.CartState,
                ...CartStateOBJ
            }
        },
        setCart: function (state, CartOBJ) {
            state.cart = {
                ...state.cart,
                ...CartOBJ
            }
        },
        setProductDetails: function (state, ProdOBJ) {
            let updatedProducts = state.cart.items.map(item => {
                if(item.handle === ProdOBJ.handle){
                    return {
                        ...item,
                        product_details: ProdOBJ.details
                    };
                }
                return item;
            })
            state.cart.items = updatedProducts.slice();
        },
        setProductDeliveryMessage: function (state, ProdOBJ) {
            let updatedProducts = state.cart.items.map(item => {
                if(item.handle === ProdOBJ.handle){
                    return {
                        ...item,
                        delivery_message: ProdOBJ.delivery_message
                    };
                }
                return item;
            })
            state.cart.items = updatedProducts.slice();
        },
        setBundles: function (state, BundlesOBJ) {
            state.bundles = BundlesOBJ
        },
        setPromo_count: function (state, value) {
            EvolveStorage.set('promoAppplieanceCount', value >= 0 ? value : state.Promo_count + 1)
            state.Promo_count = value >= 0 ? value : state.Promo_count + 1
        },
        setShipping: function (state, ShippingOBJ) {
            state.Shipping = {
                ...state.Shipping,
                ...ShippingOBJ
            }
        },
        setTotals: function (state, TotalsOBJ) {
            state.Totals = {
                ...state.Totals,
                ...TotalsOBJ
            }
        },
        setCoupons: function (state, CouponsOBJ) {
            state.Coupons = {
                ...state.Coupons,
                ...CouponsOBJ
            }
        },
        SetInventoryIncomings: function (state, InventoryIncomings) {
            state.InventoryIncomings = InventoryIncomings
        }
    }
})
Vue.filter('unformatMoney', function(moneyString){
    return parseInt(moneyString.replace('R$ ', '').replace('.', '').replace(',', ''))
});
Vue.filter('remove', function(value, keys=[], ValueDefault=''){
    var valueString = value
    if(!value){
        return ValueDefault
    }
    if(keys.length > 0){
        keys.map((key)=>{
            let pattern = key.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
            let regexKey = new RegExp(pattern, 'g');
            valueString = valueString.replace(regexKey, '')
            return valueString
        })
    }
    return valueString
});
Vue.filter('formatMoney', function (amount, decimalCount = 2, decimal = ',', thousands = '.') {
  try {
    decimalCount = Math.abs(decimalCount)
    decimalCount = isNaN(decimalCount) ? 2 : decimalCount

    const negativeSign = amount < 0 ? '-' : ''

    let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString()
    let j = (i.length > 3) ? i.length % 3 : 0

    return negativeSign + 'R$ ' + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : '')
  } catch (e) {
    console.error(e)
  }
})

Vue.use(VueMask.VueMaskPlugin);
Vue.use(window.VueAwesomeSwiper)
Vue.use(window.Vue2PerfectScrollbar)

window.MinicartApp = new Vue({
    el: '#app-Minicart',
    store: MinicartStore,
    data() {
        return {
            message: 'EvolveHubCart'
        }
    }
})